document.addEventListener('DOMContentLoaded', function () {

  // Fix href for all buttons
  document.querySelectorAll('#drop_wrapper .hero__button').forEach(btn => {
    btn.setAttribute('href', 'javascript:void(0)');
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('#drop_wrapper .hero__button');
    if (!btn) return;

    e.preventDefault(); 
    e.stopPropagation(); 
    e.stopImmediatePropagation(); // stronger prevention

    const shopifyAddToCartBtn = document.querySelector(
      '.wt-product__add-to-cart_form--wrapper .js-add-to-cart'
    );

    if (shopifyAddToCartBtn) {
        e.preventDefault(); 
    e.stopPropagation(); 
    e.stopImmediatePropagation();
      shopifyAddToCartBtn.click();
    } else {
      console.error("Shopify Add to Cart button not found.");
    }
  });

},true);